<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  <div class="page-header">
    <!-- For future development -->
    <h2>{{"binListViewBinList" | translate}}</h2>
  </div>
  <nav
    id="search-component"
    class="nav-sort-filter"
  >
    <input
      #searchBox
      type="search"
      id="search-box"
      [(ngModel)]="userFilter"
      (input)="
        this.search()
      "
      class="form-control rounded searchInput"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    />
    <select
      class="form-control ng-select sort-by-select"
      [(ngModel)]="filterBy"
      [ngClass]="{ 'has-value': filterBy }"
      (change)="onSortChange('filter', $event)"
    >
      <option value="">{{ 'filterBy' | translate }}</option>
      @for (option of filterOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>

    <select
      class="form-control ng-select sort-by-select"
      [(ngModel)]="sortBy"
      [ngClass]="{ 'has-value': sortBy }"
      (change)="onSortChange('select', $event)"
    >
      <option value="">{{ 'sortBy' | translate }}</option>
      @for (option of sortOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <div class="card-title mt-0 status">
      <label class="switch">
          <input type="checkbox" [ngModel]="this.ascDesc" (change)="onSortChange('switch', $event)">
          <span class="slider round">
            <span class="toggle-switch-label-off">{{ "asc" | translate }}</span>
            <span class="toggle-switch-label-on">{{ "desc" | translate }}</span>
          </span>
      </label>
    </div>
  </nav>
  <section class="createBtns mb-2">
    <button [ngClass]="theme.getThemeClass()" class="btn btn-dropdown"  (click)="routeToBinCreate();">
      {{  "newBin" | translate }}
    </button>
  </section>
<div class="grid-container">
  <section [ngClass]="theme.getThemeClass()" class="gridster" [ngStyle]="getColumnStyle()" >
    @for (item of this.distributors.binArray; let i = $index; track item.bin_id) {
    <article class="gridster-item">
      <!-- Your tile content goes here -->
        <nav [ngClass]="theme.getThemeClass()" class="dashboard-tile">
          <header class="dashboard-tile-header">
            <a [ngClass]="theme.getThemeClass()" [routerLink]="['/bin-update', item.bin_id]">
              <h6 class="dashboard-tile-title">{{ item.bin_name || ("binNoAddress" | translate) }}</h6>
            </a>

            @if (item.thing_name) {
            <div class="thing">
              <i class="fa-solid fa-microchip device-icon"></i><label class="item-label thing-name">{{ item.thing_name }}</label>
            </div>
            }
          </header>
          <hr>
          <div class="tiles-container">
            <!-- Section for bin infos -->
            <div class="bin-infos">
              <div class="addressFormat" (click)="displayAddress(i)" style="cursor: pointer;">
                <i class="fa-solid fa-map-marker pointer"></i><label style="cursor: pointer; "  id="{{i}}" class="address">{{ item.bin_address || "N/A" }}</label>
              </div>
              <div class="titles-items-usage">
                <i class="fa fa-trash"></i>
                <label class="item-label">{{ item.bin_usage | translate }}</label>
              </div>
            </div>
            <!-- Section for client related to the bin -->
            <hr class="hr-middle">
            <div class="client-infos">
              <div class="titles-items">
                <i class="fa fa-user"></i><label class="item-label">{{ item.legal_name || "N/A" }}</label>
              </div>
              <div class="titles-items" (click)="displayAddress('id-' + i)" style="cursor: pointer;">
                <i class="fa fa-map-marker pointer"></i><label style="cursor: pointer;" [id]="'id-' + i" class="item-label address">{{ item.address || ("binNoAddress" | translate) }}</label>
              </div>
              <div class="titles-items">
                <i class="fa fa-phone"></i><label class="item-label">{{ item.phone_number || "N/A" }}</label>
              </div>
              <div class="titles-items">
                <i class="fa-solid fa-at"></i><label class="item-label">{{ item.email || "N/A" }}</label>
              </div>
            </div>
          </div>
        </nav>
      </article>
  }
</section>
<div class="filler"></div>
</div>
</div>
